import { render, staticRenderFns } from "./level-cascade.vue?vue&type=template&id=00d8488f&"
import script from "./level-cascade.vue?vue&type=script&lang=js&"
export * from "./level-cascade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports